import './css/styles.scss';
import Swiper from 'swiper';
import { Scrollbar, Mousewheel, FreeMode, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


function initSwiper() {
    const swiper = new Swiper('.sliderspel-swiper', {
        modules: [Scrollbar, Mousewheel, FreeMode, Navigation, Autoplay],
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
        autoHeight: true,
		loop: true,
        speed: 2000,
        autoplay: {
            delay: 8000,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
    });
}

// Ensure Swiper initializes after images are processed
document.addEventListener('DOMContentLoaded', () => {
   initSwiper();
});
